export default function adjustArchiveTitle() {
	const archiveTitle = document.querySelector( '.tax-wpdmcategory .page-title' );

	if ( archiveTitle && archiveTitle.innerText.includes( 'Category: ' ) ) {
		archiveTitle.innerText = archiveTitle.innerText.substring( 10 );
		console.log( archiveTitle );
	}
}
